import React, { useMemo } from 'react'
import HomePlate from './HomePlate'
import BattersBox from './BattersBox'
import BaseLines from './BaseLines'
import Bases from './Bases'
import Rubber from './Rubber'
import { useThemeMode } from '@repo/web-ui/components/theme/ThemeProvider'

const Field = () => {
    const {mode} = useThemeMode()
    const color = useMemo(() => {return mode === 'dark' ? '#949e9b' : '#666666'},[mode])
  return (
    <group position={[0, 0, 0]} rotation={[0, 0, Math.PI]}>
        <HomePlate color={color} bgColor='#000' />
        <BattersBox color={color} bgColor='#000' />
        <BaseLines color={color} bgColor='#000' />
        <Bases color={color} bgColor='#000' />
        <Rubber color={color} bgColor='#000' />


    </group>
  )
}

export default Field